export default "__VITE_ASSET__05lOnmcS__"